import { atom } from "recoil";
import { OfficeStatusType }from "../types"

export const addStateOfficeStatus = atom({
  key: "addStateOfficeStatus",
  default: false,
});
export const editStateOfficeStatus = atom({
  key: "editStateOfficeStatus",
  default: false,
});
export const rowEditOfficeStatus = atom<OfficeStatusType | undefined>({
  key: "rowEditOfficeStatus",
  default: undefined,
});

export const selectedRowsStateOfficeStatus = atom<OfficeStatusType[]>({
  key: "selectedRowsStateOfficeStatus",
  default: [],
});

export const officeStatusFilterText = atom({
  key: "officeStatusFilterText",
  default: "",
});

export const savingOfficeStatus = atom({
  key: "savingOfficeStatus",
  default: false,
});
export const officeStatusFetching = atom({
  key: "officeStatusFetching",
  default: true,
});
export const officeStatusReFetching = atom({
  key: "officeStatusFetching",
  default: true,
});

